function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 *  Product Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/03
 */

import $ from 'jquery';
import 'slick-carousel';
import { CarouselSection } from './../carousel/CarouselSection';
import { ON_VARIANT_CHANGE } from './../../objects/swatch/Swatch';
import { register } from './../ShopifySection';
import { generatePicture, generateIcon } from '@process-creative/slate-theme-tools';
var PRODUCT_SELECTOR = '[data-product-template]';
var PRODUCT_JSON_SELECTOR = '[data-product-json]';
var VARIANT_JSON_SELECTOR = '[data-variant-json]';
export var CONTAINER_SELECTOR = '[data-product-carousel-container]';
export var CAROUSEL_SELECTOR = '[data-product-carousel]';
export var CAROUSEL_NAVIGAITON_SELECTOR = '[data-product-carousel-navigation]';
export var PRODUCT_IMAGE_SELECTOR = '[data-product-template-carousel-image]';
export var PRODUCT_THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';
export var CAROUSEL_DOTS_SELECTOR = '[data-product-carousel-dots]';
export var CAROUSEL_DOT_SELECTOR = '[data-product-carousel-dot]';
export var PRODUCT_VIDEO_SELECTOR = '[data-product-carousel-video]';
var SELECTOR_PROGRESS = '[data-carousel-progress]';

//Attrs
export var THUMBNAIL_INDEX = 'data-index';
export var PRODUCT_INITIAL_VARIANT = 'data-initial-variant-id';
export var PRODUCT_THUMBNAIL_COUNT = 'data-thumbnail-count';
export var THUMBNAIL_SELECTOR = '[data-product-template-thumbnail-image]';
export var CLASS_ACTIVE = 'is-active';

//Consts
// Should be same as in product-carousel.liquid

export var ProductCarousel = /*#__PURE__*/function (_CarouselSection) {
  _inherits(ProductCarousel, _CarouselSection);
  var _super = _createSuper(ProductCarousel);
  function ProductCarousel(container) {
    var _this;
    _classCallCheck(this, ProductCarousel);
    _this = _super.call(this, container);
    _this.carouselElem = container.find(CAROUSEL_SELECTOR);
    _this.navigation = container.find(CAROUSEL_NAVIGAITON_SELECTOR);
    _this.productThumb = container.find(PRODUCT_THUMBNAIL_SELECTOR);
    _this.thumbCount = _this.productThumb.length;
    _this.navigationDots = container.find(CAROUSEL_DOTS_SELECTOR);
    _this.productVideo = document.querySelector(PRODUCT_VIDEO_SELECTOR);
    _this.progressBar = container.find(SELECTOR_PROGRESS);
    try {
      _this.prodData = JSON.parse($(PRODUCT_SELECTOR).find(PRODUCT_JSON_SELECTOR).html());
      _this.variantData = JSON.parse($(PRODUCT_SELECTOR).find(VARIANT_JSON_SELECTOR).html());
    } catch (e) {
      console.error('could get not product or variant json data. ', e);
    }
    _this.slick = _this.initCarousel(_this.carouselElem);

    //Product Video from MF
    _this.productMetafieldVideo = _this.prodData.product_video;
    _this.productMetafieldPosition = _this.prodData.product_video_position || 2;

    //Events
    $(document).on('click', THUMBNAIL_SELECTOR, function (e) {
      return _this.onThumbnailClick(e);
    });
    container.on('click', CAROUSEL_DOT_SELECTOR, function (e) {
      return _this.onDotClick(e);
    });
    $(document).on(ON_VARIANT_CHANGE, function (e, variant) {
      return _this.onVariantChange(variant);
    });
    container.on('beforeChange', CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
      _this.goToThumb(nextSlide);
    });
    container.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      return _this.onSlickChange(e, slick, currentSlide, nextSlide);
    });
    var hasColour = _this.checkVariantColorOption();
    if (!hasColour) {
      _this.initDotsCarousel(); //Initialise Slick dots
      if (_this.thumbCount > 5) _this.initNavCarousel(); //Initialise navigation slick
      _this.initVariantImage(); //Initialise variant image
    }

    if (_this.progressBar.length) {
      container.on('beforeChange', CAROUSEL_SELECTOR, function (e, slick, currentSlide, nextSlide) {
        _this.updateProgress(slick, currentSlide, nextSlide);
      });
    }
    return _this;
  }
  _createClass(ProductCarousel, [{
    key: "initDotsCarousel",
    value: function initDotsCarousel() {
      this.dotsSlick = this.navigationDots.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        focusOnSelect: false,
        centerMode: false,
        draggable: false,
        adaptiveHeight: false,
        swipeToSlide: true
      });
      this.navigationDots.find('[data-slick-index="0"]').addClass(CLASS_ACTIVE);
    }
  }, {
    key: "initNavCarousel",
    value: function initNavCarousel() {
      this.navigationSlick = this.navigation.slick({
        mobileFirst: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        draggable: true,
        adaptiveHeight: false,
        swipeToSlide: true,
        responsive: [{
          breakpoint: 1100,
          settings: {
            infinite: true
          }
        }]
      });
    }
  }, {
    key: "initVariantImage",
    value: function initVariantImage() {
      //Set the thumb and main image on page load
      var initial = this.productThumb.attr(PRODUCT_INITIAL_VARIANT);
      var thumbTarget = $(PRODUCT_THUMBNAIL_SELECTOR + '[data-image-id="' + initial + '"]');
      var mainTarget = $(PRODUCT_IMAGE_SELECTOR + '[data-image-id="' + initial + '"]');
      if (!thumbTarget.length || !mainTarget.length) return;
      if (this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', parseInt(thumbTarget.attr(THUMBNAIL_INDEX)), false);
      this.slick.slick('slickGoTo', parseInt(mainTarget.attr(THUMBNAIL_INDEX)), false);
    }
  }, {
    key: "onSlickChange",
    value: function onSlickChange(e, slick, currentSlide, nextSlide) {
      this.dotsSlick.slick('slickGoTo', nextSlide, false);
      this.dotsSlick.find(".slick-slide").removeClass(CLASS_ACTIVE);
      this.dotsSlick.find("[data-slick-index=\"".concat(nextSlide, "\"]")).addClass(CLASS_ACTIVE);

      //Play video if it is the slide we are navigating to
      if (!this.productVideo) return;
      var next = this.slick.find("[data-slick-index=\"".concat(nextSlide, "\"]"));
      var vid = next.find(PRODUCT_VIDEO_SELECTOR);
      if (vid.length) {
        this.productVideo.play();
      } else {
        this.productVideo.pause();
      }
    }
  }, {
    key: "optionOverrides",
    value: function optionOverrides() {
      return {
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        fade: true,
        cssEase: 'linear',
        dots: false,
        adaptiveHeight: true,
        swipe: true,
        responsive: [{
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true
          }
        }]
      };
    }
  }, {
    key: "onDotClick",
    value: function onDotClick(e) {
      var self = $(e.currentTarget);
      var index = self.attr('data-index');
      this.goToSlide(index);
    }

    //Thumbnail Navigation
  }, {
    key: "onThumbnailClick",
    value: function onThumbnailClick(e) {
      var self = $(e.currentTarget);
      var index = self.attr('data-index');
      this.goToSlide(index);
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(variant) {
      if (_typeof(variant) === (typeof undefined === "undefined" ? "undefined" : _typeof(undefined))) return;

      //If this product has a colour or color option do this
      var hasColour = this.checkVariantColorOption(variant);
      if (hasColour) return;

      //Set our image, use the one for this variant, if not use default.
      if (!variant.featured_image) return;
      var imageId = variant.featured_image.id;
      var target = $(PRODUCT_THUMBNAIL_SELECTOR + '[data-image-id=' + imageId + ']');
      if (!target.length) return;
      if (this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', parseInt(target.attr(THUMBNAIL_INDEX)));
      target.trigger('click');
    }
  }, {
    key: "checkVariantColorOption",
    value: function checkVariantColorOption() {
      var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.variantData;
      var lowerOptions = this.prodData.options.map(function (o) {
        return o.toLowerCase();
      });
      var hasColour = lowerOptions.includes('color') || lowerOptions.includes('colour');
      if (!hasColour) return;
      var optionNumber = lowerOptions.reduce(function (x, option, i) {
        if (x) return x;
        if (['color', 'colour'].includes(option)) return "option".concat(i + 1);
      }, null);
      var variantColor = variant[optionNumber];
      this.rebuildProductCarouselForColour(variantColor);
      return true;
    }
  }, {
    key: "rebuildProductCarouselForColour",
    value: function rebuildProductCarouselForColour(variantColor) {
      var _this2 = this;
      this.carouselElem.slick('unslick');
      if (this.navigationSlick) {
        this.navigation.slick('unslick');
      }
      if (this.dotsSlick) {
        this.navigationDots.slick('unslick');
      }
      var images = this.prodData.media;
      var variantImages = images.filter(function (i) {
        return i.alt == variantColor;
      });
      var carouselSlickPrint = '';
      var navigationSlickPrint = '';
      var dotsSlickPrint = '';
      var mediaCount = 0;
      variantImages.forEach(function (image, i) {
        // Videos from metafields show for all colours
        // Print video if in right position
        // If video position is on last loop and has not printed, print anyway.
        if (_this2.productMetafieldVideo && mediaCount === _this2.productMetafieldPosition - 1 || variantImages.length - 1 === i && _this2.productMetafieldPosition > variantImages.length) {
          carouselSlickPrint += /*html*/"\n          <div\n            class=\"c-product-carousel__image-container\"\n            data-product-template-carousel-image\n            data-index=\"".concat(mediaCount, "\"\n          >\n            <video \n              class=\"c-product-carousel__image\" \n              playsinline=\"playsinline\" \n              loop=\"loop\" \n              preload=\"metadata\" \n              ").concat(_this2.prodData.product_video_placeholder ? "poster=\"".concat(_this2.prodData.product_video_placeholder, "\"") : "", "\n              onclick=\"this.paused ? this.play() : this.pause()\"\n              muted=\"muted\"\n              data-product-carousel-video\n            >\n              <source src=\"").concat(_this2.productMetafieldVideo, "\" type=\"video/mp4\">\n            </video>\n          </div>\n        ");
          navigationSlickPrint += /*html*/"\n          <div\n            class=\"c-product-carousel__thumb-container\"\n            data-product-template-thumbnail-image\n            data-index=\"".concat(mediaCount, "\"\n          >\n            <div class=\"c-product-carousel__thumb\">\n              <img src=\"").concat(_this2.prodData.product_video_placeholder, "\" class=\"c-product-carousel__thumb-image\"/>\n              ").concat(generateIcon('play', 'c-product-carousel__thumb-video-icon'), "\n            </div>\n          </div>\n        ");
          dotsSlickPrint += /*html*/"\n          <div\n            class=\"c-product-carousel__dot is-video\"\n            data-product-carousel-dot\n            data-index=\"".concat(mediaCount, "\"\n          >\n            <button class=\"c-product-carousel__dot-inner\">\n            </button>\n          </div>\n        ");
          mediaCount++;
        }
        if (image.media_type === 'video') {
          var videoSources = "";
          image === null || image === void 0 ? void 0 : image.sources.forEach(function (source, i) {
            videoSources += /*html*/"\n            <source src=\"".concat(source.url, "\" type=\"").concat(source.mime_type, "\">\n          ");
          });
          carouselSlickPrint += /*html*/"\n          <div\n            class=\"c-product-carousel__image-container ".concat(mediaCount == 0 ? '' : 'has-js', "\"\n            data-product-template-carousel-image\n            data-image-id=\"").concat(image.id, "\"\n            data-index=\"").concat(mediaCount, "\"\n          >\n            <video \n              playsinline=\"playsinline\" \n              loop=\"loop\" \n              class=\"c-product-carousel__main-image-video c-product-carousel__image\" \n              preload=\"metadata\" \n              aria-label=\"").concat(image.alt, "\" \n              poster=\"").concat(image.preview_image.src, "\"\n              onclick=\"this.paused ? this.play() : this.pause()\"\n              muted=\"muted\"\n              autoplay\n            >\n              ").concat(videoSources, "\n            </video>\n          </div>\n        ");
        } else {
          carouselSlickPrint += /*html*/"\n          <div\n            class=\"c-product-carousel__image-container ".concat(mediaCount == 0 ? '' : 'has-js', "\"\n            data-product-template-carousel-image\n            data-image-id=\"").concat(image.id, "\"\n            data-index=\"").concat(mediaCount, "\"\n          >\n            <img src=\"").concat(image.src, "\" class=\"c-product-carousel__image\"/>\n            ").concat(image.media_type === 'video' ? generateIcon('play', 'c-product-carousel__thumb-video-icon') : '', "\n          </div>\n        ");
        }
        navigationSlickPrint += /*html*/"\n        <div\n          class=\"c-product-carousel__thumb-container ".concat(mediaCount == 0 ? 'is-active' : '', "\"\n          data-product-template-thumbnail-image\n          data-image-id=\"").concat(image.id, "\"\n          data-index=\"").concat(mediaCount, "\"\n        >\n          <div class=\"c-product-carousel__thumb\">\n            ").concat(image.media_type === 'video' ? "<img src=\"".concat(image.preview_image.src, "\" class=\"c-product-carousel__thumb-image\"/>") : "<img src=\"".concat(image.src, "\" class=\"c-product-carousel__image\"/>"), "\n            ").concat(image.media_type === 'video' ? generateIcon('play', 'c-product-carousel__thumb-image') : '', "\n          </div>\n        </div>\n      ");
        dotsSlickPrint += /*html*/"\n        <div\n          class=\"c-product-carousel__dot ".concat(image.media_type === 'video' ? 'is-video' : '', "\"\n          data-product-carousel-dot\n          data-index=\"").concat(mediaCount, "\"\n        >\n          <button class=\"c-product-carousel__dot-inner\">\n          </button>\n        </div>\n      ");
        mediaCount++;
      });
      this.carouselElem.html(carouselSlickPrint);
      this.navigationDots.html(dotsSlickPrint);
      this.navigation.html(navigationSlickPrint);
      this.productThumb = this.container.find(PRODUCT_THUMBNAIL_SELECTOR);
      this.thumbCount = this.productThumb.length;
      this.slick = this.initCarousel(this.carouselElem);
      this.initDotsCarousel(); //Initialise Slick dots
      if (this.thumbCount > 5) this.initNavCarousel(); //Initialise navigation slick

      if (this.productMetafieldVideo) {
        this.productVideo = document.querySelector(PRODUCT_VIDEO_SELECTOR);
      }
    }
  }, {
    key: "goToSlide",
    value: function goToSlide(index) {
      this.carouselElem.slick('slickGoTo', index);
      this.setActiveImage(index);
    }
  }, {
    key: "goToThumb",
    value: function goToThumb(nextSlide) {
      if (this.thumbCount > 5) this.navigationSlick.slick('slickGoTo', nextSlide);
      this.setActiveImage(nextSlide);
    }
  }, {
    key: "setActiveImage",
    value: function setActiveImage(index) {
      $(THUMBNAIL_SELECTOR).removeClass(CLASS_ACTIVE);
      $("".concat(THUMBNAIL_SELECTOR, "[data-index=\"").concat(index, "\"]")).addClass(CLASS_ACTIVE);
    }
  }, {
    key: "onImageSlideChange",
    value: function onImageSlideChange(toSlide) {
      this.setActiveImage(toSlide);
    }
  }, {
    key: "onThumbnailSlideChange",
    value: function onThumbnailSlideChange(toSlide) {
      this.carouselElem.slick('slickGoTo', toSlide);
      this.setActiveImage(toSlide);
    }
  }, {
    key: "updateProgress",
    value: function updateProgress(slick, currentSlide, nextSlide) {
      var calc = nextSlide / slick.slideCount * 100;
      calc = calc + 100 / slick.slideCount;
      this.progressBar.css('width', calc + '%');
    }
  }]);
  return ProductCarousel;
}(CarouselSection);
register(CONTAINER_SELECTOR, ProductCarousel);